/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import Localized from '../../../../../shared/components/Localized';
import Button from '../../../../components/Button';
import Modal, { ModalFooter, ModalHeader } from '../../../../components/Modal';
import SubscribeWithChannel from '../SubscribeWithChannel';
import AllSeverityPage from './AllSeverityPage';
import InstancePage from './InstancePage';
import ServiceSeveritiesPage from './ServiceSeveritiesPage';
import SimpleInstancePage from './SimpleInstancePage';
import { getInstanceOptions } from './utils';
import { ModelHeader, ModelHeading, ModelSubHeader, ModelIntro } from '../../../../components/Modal/MobileNumberModal';

class NewSubscriptionModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      instanceOptions: [],
      generalMessageEmailSubscribed: false,
      generalMessageSMSSubscribed: false,
      instanceNameList: []
    };
  }
  componentDidMount() {
    const { instanceOrProduct, requests, subscriber } = this.props;
    const instanceNameList = requests.localizations.response.body.reduce((filtered, option) => {
      if (option.modelName === 'instance' && option.modelAttribute === "label") {
        const identifier =  { key: option.modelKey, localizedName: option.text };
        filtered.push(identifier);
      }
      return filtered;
    }, []);

    const instanceOptions = getInstanceOptions(instanceOrProduct, requests, ''); // searchKey is ''
    const { generalMessageEmailSubscribed, generalMessageSMSSubscribed } = subscriber;
    this.setState({
      instanceOptions,
      generalMessageEmailSubscribed,
      generalMessageSMSSubscribed,
      instanceNameList,
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { instanceOrProduct, requests } = this.props;
    if (instanceOrProduct !== nextProps.instanceOrProduct) {
      const instanceOptions = getInstanceOptions(nextProps.instanceOrProduct, requests, ''); // searchKey is ''

      this.setState({
        instanceOptions,
      });
    }
  }

  onInstanceFilterChange = event => {
    const searchKey = event.target.value;
    const { instanceOrProduct, requests } = this.props;
    let instanceOptions = this.state.instanceOptions;
    if (searchKey) {
      instanceOptions = getInstanceOptions(instanceOrProduct, requests, searchKey, this.state.instanceNameList);
    }
    this.setState({ instanceOptions });
  };

  toggleSubscribe = subType => {
    return () => {
      let { generalMessageEmailSubscribed, generalMessageSMSSubscribed } = this.state;
      if (subType === 'email') {
        generalMessageEmailSubscribed = !generalMessageEmailSubscribed;
      }

      if (subType === 'sms') {
        generalMessageSMSSubscribed = !generalMessageSMSSubscribed;
      }

      this.setState({
        generalMessageEmailSubscribed,
        generalMessageSMSSubscribed,
      });
    };
  };

  render() {
    const options = [
      {
        disabled: false,
        id: '_instance',
        text: 'Instance',
        value: 'instance',
      },
      {
        disabled: false,
        id: '_generalmessage',
        text: 'Informational Message',
        value: 'generalMessage',
      },
    ];

    const { instanceOrProduct, instanceKey, setInstanceKey } = this.props;

    const label = (
      <Localized
        modelKey={instanceOrProduct === 'instance' ? 'chooseAnInstance' : 'chooseAproduct'}
        modelAttribute="label"
        modelName="subscribeModal"
      />
    );

    const newProperties = {
      name: 'set' + instanceOrProduct,
      instanceOrProduct,
      instanceKey,
      setInstanceKey,
      instanceOptions: this.state.instanceOptions,
      label,
    };

    if (instanceOrProduct === 'instance') {
      newProperties.onInstanceFilterChange = this.onInstanceFilterChange;
    }

    const optionTable = instanceOrProduct === 'instance' ? <InstancePage {...newProperties} /> : null;
    const { emailAddress, phoneNumber, mobileNumberVerified } = this.props.subscriber;
    return (
      <Modal onClose={this.props.onClose}>
        <ModelHeader>
          <ModelHeading>Create Subscription</ModelHeading>
          <ModelSubHeader>
            {instanceOrProduct === 'instance' && (
              <Localized modelName={'instance'} modelKey={instanceKey} modelAttribute={'label'} />
            )}
            {instanceOrProduct === 'generalMessage' && 'Informational Message'}
          </ModelSubHeader>
        </ModelHeader>
        {this.props.page === 'instances' && (
          <div>
            <SimpleInstancePage
              name="setProductOrInstance"
              label="I Would like to subscribe TO:"
              instanceKey={instanceOrProduct}
              setInstanceKey={this.props.setProductOrInstance}
              onChange={this.props.setProductOrInstance}
              instanceOptions={options}
            />
            {optionTable}
          </div>
        )}
        {this.props.page === 'serviceSeverities' && (
          <ServiceSeveritiesPage
            instanceKey={instanceKey}
            serviceSeverityGrid={this.props.serviceSeverityGrid}
            requests={this.props.requests}
          />
        )}
        {this.props.page === 'allSeverities' && (
          <AllSeverityPage instanceKey={this.props.instanceKey} severityGrid={this.props.severityGrid} />
        )}
        {this.props.page === 'generalMessage' && (
          <SubscribeWithChannel
            instanceKey="Informational Message"
            emailAddress={emailAddress}
            phoneNumber={phoneNumber}
            mobileNumberVerified={mobileNumberVerified}
            generalMessageEmailSubscribed={this.state.generalMessageEmailSubscribed}
            generalMessageSMSSubscribed={this.state.generalMessageSMSSubscribed}
            toggleSubscribe={this.toggleSubscribe}
          />
        )}
        <ModalFooter>
          <Button onClick={this.props.previousPage}>{this.props.page === 'instances' ? 'Cancel' : 'Back'}</Button>
          <Button
            theme="brand"
            disabled={
              (!instanceKey && instanceOrProduct !== 'generalMessage') ||
              (this.props.page === 'generalMessage' &&
                !this.state.generalMessageEmailSubscribed &&
                !this.state.generalMessageSMSSubscribed)
            }
            onClick={() => {
              return this.props.nextPage(
                this.state.generalMessageEmailSubscribed,
                this.state.generalMessageSMSSubscribed
              );
            }}
          >
            {this.props.page === 'instances' ? 'Next' : 'Submit'}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default NewSubscriptionModal;
